export enum FormatFieldName {
  BUSINESS_DATE = 'Business Date',
  BUSINESS_UNIT = 'Business Unit',
  SEQUENCE = 'Sequence'
}
